<template>
  <div id="tester-home" class="container">
    <div class="row m-2">
      <h3>Active Tests</h3>
    </div>
    <div class="row m-3">
      <template v-for="t in tests">
        <button
          v-if="t.numSubmittedSequence < t.numSequence"
          class="btn btn-sm btn-outline-dark m-1"
          :key="t.id"
          @click="localEventHandler('click-test-row', { test: t })"
        >
          #{{ t.id }} ({{ t.numSubmittedSequence }}/{{ t.numSequence }})
        </button>
      </template>
    </div>
    <div class="row m-2">
      <h3>Finished Tests</h3>
    </div>
    <div class="row m-3">
      <template v-for="t in tests">
        <button
          v-if="t.numSubmittedSequence == t.numSequence"
          class="btn btn-sm btn-disabled btn-outline-dark m-1"
          :key="t.id"
        >
          #{{ t.id }}
        </button>
      </template>
    </div>
  </div>
</template>

<script>
import api_tester from '@/api/api_tester'
export default {
  data () {
    return {
      tests: []
    }
  },
  created () {
    api_tester.get_tests().then(t => {
      t.sort((a, b) => a.id - b.id)
      this.tests = t
      this.$forceUpdate()
    })
  },
  methods: {
    redirect (name, params) {
      if (name == 'do-test') {
        this.$router.push('/tester/do/' + params.id)
      }
    },
    localEventHandler (name, event) {
      if (name == 'click-test-row') {
        let t = event.test
        if (t.numSubmittedSequence < t.numSequence) {
          this.redirect('do-test', { id: t.id })
        }
      }
    }
  }
}
</script>
<style scoped>
.clickable {
  cursor: pointer;
}
.btn-disabled {
  cursor: default;
  pointer-events: none;
}
</style>
